import identity from 'lodash/identity';
import mergeWith from 'lodash/mergeWith';
import { CSSObjectWithLabel, GroupBase, StylesConfig } from 'react-select';

type StylesConfigFunction<T> = (base: CSSObjectWithLabel, props: T) => CSSObjectWithLabel;

export const combineStyles = <Option, IsMulti extends boolean, Group extends GroupBase<Option>>(
  baseStyles: StylesConfig<Option, IsMulti, Group>,
  customStyles: StylesConfig<Option, IsMulti, Group> = {},
) =>
  mergeWith(
    {},
    baseStyles,
    customStyles,
    <T>(
        base: StylesConfigFunction<T> = identity,
        custom: StylesConfigFunction<T> = identity,
      ): StylesConfigFunction<T> =>
      (css, state) =>
        custom(base(css, state), state),
  );
